import React from 'react';
import CenterPanel from './centerPanel';
import RightPanelBottom from './rightPanelBottom';
import RightPanelTop from './rightPanelTop';
import PopupHeader from '../../popupHeader';
import Model from '../../../shared/modal/content';

export class ContentWebsitButton extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  UNSAFE_componentWillReceiveProps(props) {}
  openWaitingAreaWebsiteButtonHelp() {
    window.open(APP.EXTERNAL_LINKS.WaitingArea.HelpWebsiteButtonDetails, '_blank');
  }

  render() {
    let waitingAreaName = this.props.waitingArea ? this.props.waitingArea.name : '';
    return (
      <Model show={this.props.showWaitingAreaModel} classes="wa-websiteButton invite-button">
        <PopupHeader
          title={APP.LANGUAGE.WaitingAreaWebsiteButton.TitlePartOne}
          subtitle={waitingAreaName}
          helpFunc={this.openWaitingAreaWebsiteButtonHelp}
        />

        <div className="content">
          <div className="main-ui-container meeting-room-create-update">
            <div id="righthandfloatingpanel">
              <div className="right ui rail ">
                <div className="ui sticky">
                  <RightPanelTop
                    closeModal={this.closeModal}
                    waitingAreaWebsiteButton={this.props.waitingAreaWebsiteButton}
                  />
                  <RightPanelBottom waitingArea={this.props.waitingArea} />
                </div>
              </div>

              <CenterPanel
                websiteButtonDetails={this.props.waitingAreaWebsiteButton}
                waitingArea={this.props.waitingArea}
                waitingAreaWebsiteButton={this.props.waitingAreaWebsiteButton}
                closeModal={this.closeModal}
              />
              <div className="bottom-rail-with-left-and-right-content mrtl">
                <RightPanelBottom waitingArea={this.props.waitingArea} />
                <RightPanelTop
                  closeModal={this.closeModal}
                  waitingAreaWebsiteButton={this.props.waitingAreaWebsiteButton}
                />
              </div>
            </div>
          </div>
        </div>
      </Model>
    );
  }
}
